import React from "react";
import { useDispatch } from "react-redux";
import DialogConfirm from "../../components/common/DialogConfirm";
import { useStore } from "../../hooks/useStore";
import { useTranslation } from "../../hooks/useTranslation";
import { logout } from "../../redux/actions/authActions";

export const ModalExpireSession = () => {
  const { authStore } = useStore();
  const dispatch = useDispatch();
  const handleClose = () => {};
  const { t, BundleKey } = useTranslation();

  const handleConfirm = () => {
    dispatch(logout());
  };
  return (
    <DialogConfirm
      openDialog={authStore.sessionExpire}
      titleButtonOk={t(BundleKey.ACTION_ACCEPT)}
      handleClose={handleClose}
      handleConfirm={handleConfirm}
      message={t(BundleKey.LOGOUT_EXPIRE_MESSAGE)}
      title={t(BundleKey.LOGOUT_EXPIRE_TITLE)}
    />
  );
};
